import * as dayjs from 'dayjs'
import * as plular from 'dayjs/plugin/pluralGetSet'
import 'dayjs/locale/ru'

dayjs.extend(plular);
dayjs.locale('ru-ru') // use locale

const Months = {
    '0': ['января', 'января', 'января'],
    '1': ['февраля'],
    '2': ['марта'],
    '3': ['апреля'],
    '4': ['мая'],
    '5': ['июня'],
    '6': ['июля'],
    '7': ['августа'],
    '8': ['сентября'],
    '9': ['октября'],
    '10': ['ноября'],
    '11': ['декабря']
};

export default class DateHelper {
    static getMonthWithPlurals(
        date: Date,
    ): string {
        const monthForms = Months[date.getMonth()];

        if (!monthForms) {
            return '';
        }

        return monthForms[0];
    }

    static getDateForRequest(date: Date): string {
        return dayjs(date).format('DD.MM.YYYY');
    }
}
